export default {
    path: '/andon',
    component: () => import('@/views/layout.vue'),
    redirect: '/andon',
    name: 'andon',
    sort: 5,
    icon: 'el-icon-s-opportunity',
    meta: {
        title: '安灯管理',
        authCode: ['E001']
    },
    children: [{
            path: '/andonRuleList',
            name: 'andonRuleList',
            component: () => import('@/views/permission/andon/andonRuleList.vue'),
            meta: {
                keepAlive: true,
                title: '规则管理',
                authCode: ['E0001']
            }
        },
        {
            path: '/andonOrderList',
            name: 'andonOrderList',
            component: () => import('@/views/permission/andon/andonOrderList.vue'),
            meta: {
                keepAlive: true,
                title: '安灯工单',
                authCode: ['E0002']
            }
        },
        {
            path: '/andonContentList',
            name: 'andonContentList',
            component: () => import('@/views/permission/andon/andonContentList.vue'),
            meta: {
                title: '安灯种类',
                authCode: ['E0003']
            }
        },
        {
            path: '/editRule',
            name: 'editRule',
            hidden: true,
            component: () => import('@/views/permission/andon/andon_rule_edit.vue'),
            meta: {
                title: '规则编辑',
                authCode: ''
            }
        },
        {
            path: '/addAndonRule',
            name: 'addAndonRule',
            hidden: true,
            component: () => import('@/views/permission/andon/addAndonRule.vue'),
            meta: {
                title: '规则新增',
                authCode: ''
            }
        },
        {
            path: '/andonOrderDetail',
            name: 'andonOrderDetail',
            hidden: true,
            component: () => import('@/views/permission/andon/andonOrderDetail.vue'),
            meta: {
                title: '安灯工单详情页',
                authCode: ''
            }
        }
    ]
}
